export default "__VITE_ASSET__pK93OiIi__"